import React from 'react';
export function PullQuote() {
  return <div className="bg-surface border border-border border-l-[4px] border-l-amber rounded-lg px-[30px] py-[28px] my-[2.4em] italic text-[1.12rem] text-text-mid leading-[1.75]" data-id="element-80">
      „Ich hatte Lenies Haut als das Problem betrachtet. In Wirklichkeit war die
      Haut nur das Symptom – der Darm war die Ursache."
      <cite className="block mt-3 not-italic font-sans text-[0.78rem] font-semibold text-text-muted tracking-[0.04em]" data-id="element-81">
        — Sarah M., Hundemama aus Hamburg
      </cite>
    </div>;
}